<template>
  <div class="settings-management container">
    <nav class="breadcrumb mt-5" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/admin">Admin Settings</router-link></li>
        <li class="is-active"><router-link to="/dashboard/settings-management" aria-current="true">Settings Management</router-link></li>
      </ul>
    </nav>
    
    <h1 class="title">Application Settings</h1>
    
    <button class="button is-danger is-small mb-3" @click="restoreDefaults">Restore to Default</button>
    
    <table class="table is-striped is-fullwidth is-size-7">
      <thead>
        <tr>
          <th>Category</th>
          <th>Key</th>
          <th>Value</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(settingsGroup, category) in groupedSettings" :key="category">
          <tr v-for="(setting, index) in settingsGroup" :key="index">
            <td>{{ category }}</td>
            <td>{{ setting.key }}</td>
            <td>
              <span v-if="!setting.isEditing">{{ setting.value }}</span>
              <input v-else class="input is-small" v-model="setting.value" />
            </td>
            <td>
              <button v-if="!setting.isEditing" class="button is-info is-small mr-2" @click="editSetting(setting)">Edit</button>
              <button v-else class="button is-success is-small mr-2" @click="confirmSave(setting)">Save</button>
              <button v-if="setting.isEditing" class="button is-danger is-small" @click="cancelEdit(setting)">Cancel</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';
import { toast } from 'bulma-toast';

export default {
  name: 'SettingsManagement',
  data() {
    return {
      settings: []
    };
  },
  computed: {
    groupedSettings() {
      const groups = {};
      this.settings.forEach(setting => {
        const category = setting.category || 'General';
        if (!groups[category]) groups[category] = [];
        groups[category].push(setting);
      });
      return groups;
    }
  },
  methods: {
    async fetchSettings() {
      try {
        const response = await axios.get('/api/v1/configuration/settings');
        this.settings = response.data.map(setting => ({
          ...setting,
          isEditing: false,
          originalValue: setting.value
        }));
      } catch (error) {
        console.error('Error fetching settings:', error);
        toast({ message: 'Error fetching settings', type: 'is-danger' });
      }
    },
    editSetting(setting) {
      setting.isEditing = true;
    },
    cancelEdit(setting) {
      setting.value = setting.originalValue;
      setting.isEditing = false;
    },
    async confirmSave(setting) {
      if (confirm('Are you sure you want to save this change?')) {
        this.saveSetting(setting);
      }
    },
    async saveSetting(setting) {
      try {
        await axios.put(`/api/v1/configuration/settings/${setting.id}/`, setting);
        toast({ message: 'Setting saved successfully!', type: 'is-success' });
        setting.originalValue = setting.value;
        setting.isEditing = false;
      } catch (error) {
        console.error('Error saving setting:', error);
        toast({ message: 'Failed to save setting', type: 'is-danger' });
      }
    },
    async restoreDefaults() {
      if (confirm('Are you sure you want to restore all settings to their default values?')) {
        try {
          await axios.post('/api/v1/configuration/settings/restore-defaults/');
          toast({ message: 'All settings restored to default values!', type: 'is-success' });
          await this.fetchSettings();  // Reload settings after reset
        } catch (error) {
          console.error('Error restoring defaults:', error);
          toast({ message: 'Failed to restore defaults', type: 'is-danger' });
        }
      }
    }
  },
  async created() {
    await this.fetchSettings();
  }
};
</script>

<style scoped>
.container {
  max-width: 900px;
  margin: 0 auto;
}
.table {
  margin-top: 20px;
}
.input {
  width: 100%;
}
</style>
